import React from 'react';

import DownloadImg from '../../images/download.png';

const DownloadButton = ({ className }) => {
  return (
    <button className={`rounded p-4 flex items-center shadow-cfw ${className}`}>
      Download{' '}
      <span className="rounded-full w-6 h-6 ml-2">
        <img src={DownloadImg} alt="DownloadImg" />
      </span>
    </button>
  );
};

export default DownloadButton;
